import api from "./api.service";

export interface Expediente {
  id: number;
  nro_expediente: string;
  tipo_expediente: string;
  estado: string;
  tipo_estado: string;
  organo_jurisdiccional: string;
  demandante: string;
  demandados: string | null;
  partes_procesales: string;
  fecha_ingreso: string;
  materia: string;
  observaciones: string | null;
  telefono?: string | null;
  telefono_doxeado?: string | null;
  revisado?: boolean;
}

export const getExpedientesPorMes = async (anio: number, mes: number) => {
  const resp = await api.get("/expedientesin", { params: { anio, mes } });
  return resp.data;
};

export const marcarRevisado = async (id: number) => {
  const resp = await api.post(`/expedientesin/${id}/revisar`);
  return resp.data;
};

export const guardarTelefono = async (id: number, telefono: string) => {
  const resp = await api.post(`/expedientesin/${id}/telefono`, { telefono });
  return resp.data;
};
